module.exports = __webpack_public_path__ + "img/sanmarino.f1f2bbce.svg";